export const DOUBLE_ELIMINATION_TYPE = 'doubleElimination'

export const GRAND_FINAL_TYPE = 'grand-final'
